// Market accounts
if (Shopify.designMode) {
  console.info("Design mode - Helpscout is OFF");
} else {

  const beacons = {
    "UK": "a9655808-f3b5-4316-be39-b593a98d0dab",
    "US": "d9f72678-b0a1-4a25-9258-f8c6b9565f5c"
  };

  let market;
  const country = Shopify.country;

  switch (country) {
    case 'US':
    case 'MX':
    case 'CA':
      market = "US";
      break;

    default:
      market = "UK";
  }

  if (beacons[market] && beacons[market] !== "") {
    // Helpscout generic load
    !(function(e, t, n) {
      function a() {
        var e = t.getElementsByTagName("script")[0],
          n = t.createElement("script");
        (n.type = "text/javascript"),
          (n.async = !0),
          (n.src = "https://beacon-v2.helpscout.net"),
          e.parentNode.insertBefore(n, e);
      }

      if (
        ((e.Beacon = n =
          function(t, n, a) {
            e.Beacon.readyQueue.push({ method: t, options: n, data: a });
          }),
          (n.readyQueue = []),
        "complete" === t.readyState)
      )
        return a();
      e.attachEvent
        ? e.attachEvent("onload", a)
        : e.addEventListener("load", a, !1);
    })(window, document, window.Beacon || function() {
    });

    // Init localised beacon
    window.Beacon("init", beacons[market]);
  }

}
